import { Search, SwapHorizontalCircle, Visibility } from "@mui/icons-material";
import { Box, Grid, TextField, Typography } from "@mui/material";
import useApi from "_api/index";
import Actions from "components/Car/Actions";
import TableData from "components/Car/Table";
import ChipCustomize from "components/Chip";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import ModalDetailCar from "components/Modal/Car/ModalDetailCar";
import CustomPagination from "components/TableExplanded/Pagination";
import { useEffect, useState } from "react";
import { formatDateTime } from "utils/helpers/format";

const BinCars = () => {
  const [loading, setLoading] = useState(false);
  const [binCars, setBinCars] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [filter, setFilter] = useState({
    search: "",
    searchName: "",
    searchIdcard: "",
  });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    fetchData();
  }, [pagination.page, pagination.limit]);

  const fetchData = async (isClear = false) => {
    setLoading(true);
    try {
      const response = await useApi.list_by_customer_car.getListBinCars({
        page: pagination.page,
        limit: pagination.limit,
        ...(!isClear && filter),
      });
      if (response.success) {
        const { data, meta } = response;
        let formattedData = data.map((item) => ({
          ...item.car,
          ...item.customer,
          ...item,
        }));
        setBinCars(formattedData ?? []);
        setPagination({
          page: meta.page || 1,
          limit: meta.limit || 10,
          total: meta.total || 0,
          totalPages: meta.totalPages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      // Finalize loading state here
    }
  };

  const recoverOrder = async (order_id) => {
    try {
      const response =
        await useApi.list_by_customer_car.putRecoverOrderFromTrash(order_id);
      if (response.isStatus) fetchData();
    } catch (error) {
      console.error("Error DeleteOrder data:", error);
    }
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
    setSelectedRow(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          ถังขยะ
        </Typography>
      </Box>

      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
        }}
      >
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                รหัสรายการ
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="รหัสรายการ"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.search}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    search: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3} textAlign={"right"}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                ชื่อ-สกุล
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="ชื่อ-สกุล"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.searchName}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    searchName: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                เลขบัตรประชาชน
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="เลขบัตรประชาชน"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.searchIdcard}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    searchIdcard: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 2,
          gap: 2,
        }}
      >
        <GradientButtonOutline
          onClick={() => {
            setFilter({
              search: "",
              searchName: "",
              searchIdcard: "",
            });
            if (pagination.page !== 1) {
              setPagination((prev) => ({
                ...prev,
                page: 1,
              }));
            } else {
              fetchData(true);
            }
          }}
          sx={{
            px: 3,
            height: "40px",
          }}
        >
          ล้าง
        </GradientButtonOutline>
        <GradientButton
          onClick={() => {
            fetchData();
          }}
          sx={{
            px: 3,
            height: "40px",
          }}
          endIcon={<Search fontSize="medium" />}
        >
          ค้นหา
        </GradientButton>
      </Box>

      {/* Add your table or list component here to display binCars */}
      <TableData
        data={binCars}
        loading={loading}
        columns={[
          {
            key: "expand",
            label: "",
            style: {
              textAlign: "center",
            },
          },
          {
            key: "car_picture",
            label: "รูปภาพ",
          },
          { key: "order_code", label: "รหัสรายการ" },
          { key: "customer_idcard", label: "เลขบัตรประชาชน" },
          { key: "customer_name", label: "ชื่อ-สกุล" },
          { key: "car_price", label: "จำนวนเงิน" },
          {
            key: "updated_at",
            label: "วันที่ย้ายมายังถังขยะ",
            render: (row) => {
              return row.updated_at ? formatDateTime(row.updated_at) : "-";
            },
          },
          {
            key: "order_type",
            label: "ประเภท",
            render: (row) => {
              return <ChipCustomize status={row.order_type} />;
            },
          },
          {
            key: "action",
            label: "",
            style: {
              textAlign: "center",
            },
            render: (row) => (
              <Actions
                menuList={[
                  {
                    label: "ดูรายละเอียด",
                    icon: <Visibility />,
                    onClick: () => {
                      setSelectedRow(row);
                      setIsOpenModal(true);
                    },
                  },
                  {
                    label: "นำกลับไปใช้",
                    icon: <SwapHorizontalCircle />,
                    onClick: () => {
                      recoverOrder(row.order_id);
                    },
                  },
                ]}
              />
            ),
          },
        ]}
      />
      <CustomPagination
        totalPage={pagination.totalPages}
        page={pagination.page - 1}
        onPageChange={(event, value) => {
          setPagination((prev) => ({
            ...prev,
            page: value + 1,
          }));
        }}
        rowsPerPage={pagination.limit}
        onRowsPerPageChange={(event) => {
          setPagination((prev) => ({
            ...prev,
            limit: event.target.value,
            page: 1, // Reset to first page when changing rows per page
          }));
        }}
      />

      <ModalDetailCar
        open={isOpenModal}
        onClose={handleCloseModal}
        rowID={selectedRow ? selectedRow.car_id : null}
        type="list_by_customer_car"
      />
    </Box>
  );
};

export default BinCars;
